import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { Title } from "../../components/ui/title";
import { useLanguage } from "../../hooks/useLanguage";
import { Solution } from './content/model';
import { Button } from "../../components/ui/button";
import styles from "./index.module.scss";

import frenchJson from './content/fr.json';
import englishJson from './content/en.json';

import redCross from "../../assets/icons/red-cross.svg";
import greyCross from "../../assets/icons/grey-cross.svg";
import mountains from "../../assets/illustrations/mountains.svg";

function parseBold(text?: string) {
    if (!text) return null;
    // Remplace **texte** par <strong>texte</strong>
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return parts.map((part, i) => {
        if (/^\*\*[^*]+\*\*$/.test(part)) {
            return <strong key={i}>{part.replace(/\*\*/g, "")}</strong>;
        }
        return part;
    });
}

interface SolutionsProps {
    id?: string;
}

export const Solutions = ({ id }: SolutionsProps) => {
    const { t } = useTranslation();
    const { language } = useLanguage();

    const content: Solution[] = language === 'fr' ? (frenchJson as Solution[]) : (englishJson as Solution[]);

    return (
        <div className={styles.mountains} id={id}>
            <img className={styles.mountainsImage} src={mountains} alt="Mountains" />
            <div className={styles.solutionsPage}>

                <Title color="white">{t('solutions.title')}</Title>

                <div className={styles.solutionsList}>
                    {content.map((solution, index) => (
                        <div className={styles.solution} key={index}>

                            <div key={index} className={styles.content}>

                                <h2>{solution.title}</h2>
                                <p className={styles.description}>{solution.description}</p>
                                <div className={styles.offer}>
                                    {solution.offer.map((offer, offerIndex) => (

                                        <div key={offerIndex} className={styles.offerItem}>
                                            <img className={offer.content ? '' : styles.hide} src={redCross} alt="Cross" />
                                            <div className={styles.offerText}>
                                                {offer.content && <p className={styles.offerTitle}>{parseBold(offer.content)}</p>}
                                                {offer.description && <p className={styles.offerDescription}>{parseBold(offer.description)}</p>}

                                                {!offer.content && <p className={styles.empty}>—</p>}
                                            </div>
                                        </div>

                                    ))}
                                </div>

                            </div>

                            <div className={styles.public}>

                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" className={styles.line}><path d="M0 0.5H1104"/></svg>
                                <p className={styles.publicDescription}>{content[index].public.description}</p>

                                <div className={styles.examples}>
                                    {content[index].public.examples.map((example, exampleIndex) => (
                                        <div key={exampleIndex} className={styles.example}>
                                            <img src={greyCross} alt="Cross" />
                                            <p>{example}</p>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    ))}
                </div>

                <div className={styles.footer}>
                    <Button color="white" isFullWidth onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}>
                        {t('global.contact')}
                    </Button>
                    <p className={styles.price}>{t('solutions.price')}</p>
                </div>
            </div>
        </div>
    );
};